enum PlanEditResultShiftEnum {
    First = 'first',
    Last = 'last',
}
export default PlanEditResultShiftEnum;
